import { CheckIcon } from "@/components/Icons/CheckIcon";
import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import { Inline } from "@/design-system/Inline";
import { Stack } from "@/design-system/Stack";
import { useTranslation } from "@/translations";

type AdminCreatePostTipsModalProps = ModalBaseProps;
export function AdminCreatePostTipsModal({ isOpened, onOpenChange }: AdminCreatePostTipsModalProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Modal.Root
      title={t("page.message-feed.create.tips.title")}
      {...{
        isOpened,
        onOpenChange,
      }}
    >
      <Modal.Body>
        <Stack as="ul" gap="sm">
          <li>
            <Inline gap="sm" align="center">
              <CheckIcon />
              <span className="text-caption">{t("page.message-feed.create.tips.1")}</span>
            </Inline>
          </li>
          <li>
            <Inline gap="sm" align="center">
              <CheckIcon />
              <span className="text-caption">{t("page.message-feed.create.tips.2")}</span>
            </Inline>
          </li>
          <li>
            <Inline gap="sm" align="center">
              <CheckIcon />
              <span className="text-caption">{t("page.message-feed.create.tips.3")}</span>
            </Inline>
          </li>
          <li>
            <Inline gap="sm" align="center">
              <CheckIcon />
              <span className="text-caption">{t("page.message-feed.create.tips.4")}</span>
            </Inline>
          </li>
          <li>
            <Inline gap="sm" align="center">
              <CheckIcon />
              <span className="text-caption">{t("page.message-feed.create.tips.5")}</span>
            </Inline>
          </li>
          <li>
            <Inline gap="sm" align="center">
              <CheckIcon />
              <span className="text-caption">{t("page.message-feed.create.tips.6")}</span>
            </Inline>
          </li>
        </Stack>
      </Modal.Body>
    </Modal.Root>
  );
}
